module.exports = __webpack_public_path__ + "static/media/netia logo.fc60e7f1.png";